module.exports = __webpack_public_path__ + "img/input-roster.1986b9c9.png";